module.exports = __webpack_public_path__ + "static/media/graph-stats.04c0b2ff.svg";